import find from "lodash/fp/find";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";

import selectUserChoices from "./selectUserChoices";

export default function selectProductBadgeImages(state) {
  const { selectedCustomisationId, selectedProductId } = state.app;
  const userChoices = selectUserChoices(state);

  return flow(
    getOr([], ["app", "formData", "products"]),
    find(({ id }) => id === selectedProductId),
    getOr([], ["customisations"]),
    find(({ id }) => id === selectedCustomisationId),
    getOr([], ["fields"]),
    flatMap(({ name, imageBadgePosition }) => {
      const {
        label,
        imageBadges = [],
        details = {},
        video = {},
        position = {},
      } = getOr({}, [name, "selectedOption"])(userChoices);

      return imageBadges.map((imageBadge) => {
        return {
          label,
          ...imageBadge,
          details,
          video,
          position: imageBadgePosition || position,
        };
      });
    })
  )(state);
}
